export default __webpack_public_path__ + "static/media/boatImg.01f4f254.png";